import React from 'react'
import screenshotVis from '../CostBurdenVis/screenshotVis'
import styles from './styles.module.css'

export default function(props) {
  const { view, sourceText } = props

  // eslint-disable-next-line no-unused-vars
  function handleClickPNG() {
    screenshotVis('png')
  }

  // eslint-disable-next-line no-unused-vars
  function handleClickPDF() {
    screenshotVis('pdf')
  }

  return (
    <div className={styles.footer}>
      <div className={styles.footerText}>
        <p>
          <strong>Source:</strong>
          {` ${sourceText}`}
        </p>
      </div>
    </div>
  )
}
